export default __webpack_public_path__ + "static/media/down-pixel.98dc385a.svg";